import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { clearLocalStorage } from '../../helper/storage'
import { axiosInstance } from '../../axios/interceptor'

export const getAllCards = createAsyncThunk('payment/cards/all', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/client/client-cards/get-all-client-cards`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const addNewCard = createAsyncThunk('payment/card/add', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/client/client-cards/create-client-cards`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const updateCard = createAsyncThunk('payment/card/update', async (params, { rejectWithValue }) => {
  const data = params?.data
  try {
    const response = await axiosInstance.put(`/client/client-cards/update-client-cards/${params?.id}`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const setDefaultCard = createAsyncThunk('payment/card/default', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/client/client-cards/set-default-card`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const deleteCard = createAsyncThunk('payment/card/delete', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.delete(`/client/client-cards/delete-client-cards/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

const initialState = {
  isLoading: false,
  allCards: [],
  error: null
}

const PaymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    resetAuthState: () => {
      clearLocalStorage()
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCards.pending, (state) => {
        state.isLoading = true
        state.allCards = []
      })
      .addCase(getAllCards.fulfilled, (state, action) => {
        state.isLoading = false
        state.allCards = action.payload?.data?.data
      })
      .addCase(getAllCards.rejected, (state, action) => {
        state.isLoading = false
        state.allCards = []
        state.error = action.error.message
      })
      .addCase(addNewCard.pending, (state) => {
        state.isLoading = true
      })
      .addCase(addNewCard.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(addNewCard.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(updateCard.pending, (state) => {
        state.isLoading = true
      })
      .addCase(updateCard.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(updateCard.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(setDefaultCard.pending, (state) => {
        state.isLoading = true
      })
      .addCase(setDefaultCard.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(setDefaultCard.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(deleteCard.pending, (state) => {
        state.isLoading = true
      })
      .addCase(deleteCard.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(deleteCard.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export const { resetAuthState } = PaymentSlice.actions
export default PaymentSlice.reducer
